import { IState } from 'legacy/lut/store'

export const selectQbrState = (state: IState) => state.partner360.qbr
